export enum NetworkErrorCodes {
    FORBIDDEN = 403,
    NOT_FOUND = 404,
}
